<div class="row"><span  class="col-sm-12" *ngIf="config.options?.inputExtraLabels && !config.options?.inputExtraLabelsTitle">{{config.options.inputExtraLabels}}</span></div>
<div class="row"><span  class="col-sm-12" *ngIf="config.options?.inputExtraLabels && config.options?.inputExtraLabelsTitle">
  <label class="col-sm-3 control-label" style="margin-left: -14px;">{{ config.options?.inputExtraLabelsTitle | translate:locale.language}}</label>
  <span class="col-sm-9" style="margin-left: 6px;">{{config.options.inputExtraLabels}}</span></span></div>
<div *ngIf="toggleElements && config.options.hideAll!=='hide' && config.options.hideAll!=='notDisplay'" [formGroup]="group" [class.form-group]="!group.disabled" class="row align-baseline" >

  <!-- label if isEdit  -->
  <label *ngIf="!config.options.longInput && (getControlName && getControlName.enabled || config.presentation === 'filter' || config.presentation === 'detail')
                || (config.presentation === 'edit' && config.options.labelShowInDetail)"
                for="{{config.label}}" class="control-label" style="white-space: nowrap;"
                [class.col-sm-4]="config.options.inputOptions"
                [class.col-sm-3]="!config.options.inputOptions">
    {{config.label | translate:locale.language}}
  </label>

  <div class="parent-container"
       [class.shortInput]="config?.options?.shortInput"
       [class.col-sm-7]="config.options.inputOptions"
       [class.col-sm-12]="config.options.longInput"
       [class.col-sm-9]="!config.options.inputOptions">

    <!--  normal form  -->
    <div *ngIf="getControlName && getControlName.enabled && config.presentation === 'edit'" style="width: 100%;">

      <input style="zoom:75%; font-size: 18px;"
             formControlName="{{config.controlName[0]}}"
             ctrl-error
             autocomplete="off"
             [error]="errorAllow"
             class="form-control pull"
             id="{{config.label}}"
             placeholder="{{config.placeholder| translate:locale.language}}"
             [required]="getControlName?.errors !== null && getControlName?.errors['required']"
             type="{{config.options.inputType?.type ? config.options.inputType?.type : ''}}"
             step="{{config.options.inputType?.step ? config.options.inputType?.step : ''}}">
      <!-- errors form -->
      <div>
          <span *ngIf="getControlName?.errors !== null && getControlName?.errors['duplicate']" class="icon-duplicate">
            <i tooltip="Duplicate name." class="fal fa-copy"></i>
          </span>
        <span *ngIf="duplicate" class="icon-duplicate">
            <i tooltip="Duplicate name." class="fal fa-copy"></i>
          </span>
        <span *ngIf="getControlName?.enabled && getControlName?.errors !== null && getControlName?.errors['errorAllow']" class="icon-network-broken">
            <i class="fal fa-times"></i>
          </span>
        <span *ngIf="showWarning" class="icon-warning">
         <i *ngIf="config.controlName[0] === 'ssid'"  tooltip="{{ 'WARNING_SSID_SPACE' | translate:locale.language}}"  class="tooltip-350 fas fa-exclamation-triangle"></i>
         <i *ngIf="config.controlName[0] === 'security_password'" tooltip="{{ 'WARNING_PASSWORD_SPACE' | translate:locale.language}}"  class="tooltip-350 fas fa-exclamation-triangle"></i>
        </span>
          <span *ngIf="group.enabled && getControlName?.invalid && !getControlName?.value" class="icon-mandatory">*</span>
      </div>

    </div>

    <!-- filter form -->
    <div *ngIf="config.presentation === 'filter'" style="width: 100%;">
      <input formControlName="{{config.controlName[0]}}"
             class="form-control"
             id="{{config.label}}"
             autocomplete="off"
             type="{{config.options.inputType?.type ? config.options.inputType?.type : ''}}"
             step="{{config.options.inputType?.step ? config.options.inputType?.step : ''}}">
    </div>

    <!-- presentation form  -->
    <div *ngIf="(getControlName && getControlName.disabled && getControlName?.value) || config.presentation === 'detail'" style="width: 100%;">
      <label *ngIf="config.options.split" style="font-weight: bold;">
        <div>
          <div *ngFor="let item of getControlName?.value.split(',');">
            {{item}}
          </div>
        </div>
      </label>
      <!-- simple -->
      <label *ngIf="config.options.show" style="font-weight: bold;">{{getControlName?.value}}</label>
      <!-- concatenate -->
      <label *ngIf="config.options.concatenate"  style="font-weight: bold; white-space: nowrap;">{{getValueFromGroup()}}</label>
      <!-- WARNING -->
      <span *ngIf="showWarning" class="icon-warning">
         <i *ngIf="config.controlName[0] === 'ssid'"  tooltip="{{ 'WARNING_SSID_SPACE' | translate:locale.language}}"  class="tooltip-350 fas fa-exclamation-triangle"></i>
         <i *ngIf="config.controlName[0] === 'security_password'" tooltip="{{ 'WARNING_PASSWORD_SPACE' | translate:locale.language}}"  class="tooltip-350 fas fa-exclamation-triangle"></i>
        </span>
    </div>

  </div>
  <span *ngIf="config.options.unit" translate>{{config.options.unit}}</span>

  <storever-input-options  class="col-sm-1" *ngIf="config.options.inputOptions" [config]="config"></storever-input-options>

</div>

<!-- DEBUG -->
<div *ngIf="false" style="display:flex;">

<!--  <pre style="flex:1;word-break:break-word;line-height:2;">config.options: {{config|json}}</pre>-->
<!--  <pre style="flex:1;word-break:break-word;line-height:2;">config.options: {{group.value |json}}</pre>-->
  <pre style="flex:1;word-break:break-word;line-height:2;">{{getControlName?.errors |json}}</pre>
</div>
